import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "../api/axios";

export default function BrandList() {
  const [brands, setBrands] = useState([]);

  const fetchBrands = async () => {
    try {
      const res = await axios.get("/admin/brands");
      setBrands(res.data);
    } catch (err) {
      console.error("Error fetching brands:", err);
    }
  };

  useEffect(() => {
    fetchBrands();
  }, []);

  const deleteBrand = async (id) => {
    if (!window.confirm("Are you sure you want to delete this brand?")) return;
    try {
      await axios.delete(`/admin/brands/${id}`);
      fetchBrands();
    } catch (err) {
      console.error("Error deleting brand:", err);
    }
  };

  return (
    <div className="container mt-5">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3>Brands</h3>
        <Link to="/admin/brands/create" className="btn btn-primary">
          Add Brand
        </Link>
      </div>

      <div className="card shadow">
        <div className="card-body">
          {brands.length === 0 ? (
            <p>No brands found.</p>
          ) : (
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Name</th>
                  <th>Image</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {brands.map((brand) => (
                  <tr key={brand.id}>
                    <td>{brand.id}</td>
                    <td>{brand.name}</td>
                    <td>
                      {brand.image_url ? (
                        <img
                          src={brand.image_url}
                          alt={brand.name}
                          style={{ width: "60px", height: "60px", objectFit: "cover" }}
                          className="img-thumbnail"
                        />
                      ) : (
                        "No Image"
                      )}
                    </td>
                    <td>
                      <Link
                        to={`/admin/brands/${brand.id}/edit`}
                        className="btn btn-sm btn-warning me-2"
                      >
                        Edit
                      </Link>
                      <button
                        className="btn btn-sm btn-danger"
                        onClick={() => deleteBrand(brand.id)}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
}
